export default () => {
    fixedImages ()
}

export function fixedImages (){
    document.addEventListener("DOMContentLoaded", () => {
        const heroWrapper = document.getElementById("heroImageWrapper");
        const observerTarget = document.getElementById("Over_PGHW_mobile");

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    heroWrapper.classList.add("fixed");
                    heroWrapper.classList.remove("relative");
                } else {
                    heroWrapper.classList.remove("fixed");
                    heroWrapper.classList.add("relative");
                }
            },
            {
                root: null,
                threshold: 0,
            }
        );

        observer.observe(observerTarget);
    });
    const elements = [
        { wrapperId: 'heroImageWrapper1', containerId: 'PGHW2' },
        { wrapperId: 'heroImageWrapper2', containerId: 'PGHW3' }
    ];

    window.addEventListener('scroll', function () {
        const scrollY = window.scrollY;

        elements.forEach(({ wrapperId, containerId }) => {
            const wrapper = document.getElementById(wrapperId);
            const container = document.getElementById(containerId);

            if (!wrapper || !container) return;

            const rect = container.getBoundingClientRect();
            const isInViewport = rect.bottom > 0 && rect.top < window.innerHeight;

            if (scrollY >= 100 && isInViewport) {
                wrapper.classList.add('fixed');
                wrapper.classList.remove('absolute');
            } else {
                wrapper.classList.remove('fixed');
                wrapper.classList.add('absolute');
            }
        });
    });
}
